import React, { createRef } from 'react';
import ReactDOM from 'react-dom/client';
import PromptDialog from './components/PromptDialog'; // Updated import
import './PromptDialog.css';

// Store references to the root and component instance
let root = null;
let componentRef = createRef();

// The public API for our library
const PromptAtPrint = {
  /**
   * Initializes and renders the React component.
   * @param {object} config - The configuration object.
   * @param {Array} config.initialLabelsData - The data for the labels.
   * @param {Function} config.onFinish - A callback function executed when the finish button is clicked.
   */
  init: ({ initialLabelsData, onFinish, onCancel }) => {
    let dialogContainer = document.createElement('div');
    document.body.appendChild(dialogContainer);
    root = ReactDOM.createRoot(dialogContainer);

    // The onClose function will be called from within the component to unmount itself
    const handleClose = () => {
        if(onCancel) { // <-- Call onCancel if it was provided
          onCancel();
        }
        if(root) {
            root.unmount();
            root = null;
        }
    }
    
    // Render the PromptDialog component
    root.render(
      <React.StrictMode>
        <PromptDialog 
          ref={componentRef}
          initialLabelsData={initialLabelsData} 
          onFinish={onFinish}
          onClose={handleClose}
        />
      </React.StrictMode>
    );
  },

  /**
   * Closes and unmounts the React component.
   */
  close: () => {
    if (componentRef.current) {
      componentRef.current.close();
    }
  },
};

// This line makes the API available on the window object when the script is included in a browser.
if (typeof window !== 'undefined') {
  window.PromptAtPrint = PromptAtPrint;
}

export default PromptAtPrint;